module.exports = __webpack_public_path__ + "static/How-to-manage-tabs-11-e1403552869495-385a41b8b3a51266c4b0f3ef49d28dc2.jpg";